<template>
    <div>
        <div class="">
	        <select-field caption="Action"
	                      :options="actions"
	                      label="caption"
	                      placeholder="Select an action to trigger"
	                      @input="actionChanged"
	                      v-model="automation.type_id" :loading="spin" />
        </div>

        <div class="margin-t-25" v-if="automation.type_id && spreadSheets.length">
	        <select-field caption="Spreadsheet"
	                      placeholder="Select a spreadsheet"
	                      searchable clearable
	                      label="name"
	                      :options="spreadSheets"
	                      @input="spreadsheetChanged($event)"
	                      v-model="content.spreadsheet_id" :loading="spin" />
        </div>
	      <div v-else-if="!automation.type_id" class="flex layout-row margin-t-25">
		      <span class="info-message " style="margin: auto">Select an action to be triggered first.</span>
	      </div>

        <div class="margin-t-25" v-if="sheets.length || content.spreadsheet_id">
	        <select-field caption="Sheet"
	                      placeholder="Select a sheet"
	                      searchable clearable no-reduce
	                      :options="sheets"
	                      label="name"
	                      @input="sheetChanged($event)"
	                      :value="sheetValue" :loading="spin" />
        </div>

	    <GoogleSheetMapping class="margin-t-25" v-if="showMappings"
	                        :fields="selectedFields"
	                        :mappings="content.mappings"
	                        @mapping="onMapping" />
    </div>
</template>

<script>
import API from "@/api"
import VSpinner from "@/components/base/v-spinner";
import Loading from "@/components/Loading";
import GoogleSheetMapping from "@/components/integrations/GoogleSheetMapping";
import SelectField from "@/components/base/select-field";
export default {
  name: 'GoogleSheets',
  components: {
	  SelectField,
    GoogleSheetMapping,
    Loading,
    VSpinner,
  },
  mixins: [API],
	props:{
		automation:{
			type:Object,
			// default:()=> {}
		},
		product:{
			type:Object,
		},
		actions:{
			type:Array,
		},
		integration:{
			type:Object,
		},
	},
	data() {
    return {
      spin: false,
      spreadSheets: [],
      sheets: [],
      fields: [],
      selectedFields: [],
      selectedSheet: null,
      initialLoad:false,
    }
  },
  computed: {
		sheetValue(){
			return {
				id: this.content.sheet_id,
				name: this.content.sheet_name,
			}
		},
		isValid(){
			return !!(this.automation.type_id && this.content.spreadsheet_id && this.content.sheet_name)
		},
	  content(){
			return this.automation.content;
	  },
    showMappings() {
      return !!(this.automation.type_id && this.content.spreadsheet_id && this.content.sheet_name)
    }
  },
  watch: {
    // fields(val) {
    //     if(val.length && this.selectedSheet !== '') {
    //         this.selectedFields = this.fields.find(item=>parseInt(item.id) === parseInt(this.selectedSheet));
    //     }
    // },
  },
  methods: {
		updated(){
			let ss = this.spreadSheets.find(x => x.id === this.automation.content.spreadsheet_id)
			this.automation.action_caption = ss ? ss.name : '';

			let sheet = this.sheets.find(x => x.id === this.automation.content.sheet_id)
			this.$set(this.automation.content, 'sheet_name', sheet ? sheet.name : '')
			this.$set(this.automation.content, 'sheet_id', sheet ? parseInt(sheet.id) : null)

			this.$emit('valid', this.isValid)
		},
    async actionChanged(action) {
			if (!action || this.initialLoad) return;

      // this.automation.type_id = action;

			await this.loadSpreadsheets()
      this.updated()
    },
	  async loadSpreadsheets(){
		  try {
			  this.spin = true;
			  this.spreadSheets = [];
			  this.spreadSheets = await this.api.integrations.method(this.integration.name,'get-spreadsheets',{})
		  } catch (e) {
			  this.$error(e, "Something went wrong! try again, make sure your Google account is connected properly.")
		  } finally {
			  this.spin = false;
		  }
	  },
	  async spreadsheetChanged(spreadsheet_id) {
			if (this.initialLoad) return;
		  // this.content.spreadsheet_id = spreadsheet_id;
			await this.loadSheets();
			await this.loadSheetFields();
		  this.updated()
	  },
    async loadSheets() {
			try {
	      this.spin = true;
				this.sheets = [];

				if (!this.content.spreadsheet_id) return;

				let res = await this.api.integrations.method(this.integration.name,'get-sheets',{arg1:this.content.spreadsheet_id})
	      if (res && !res.error) {
		      this.sheets = res
	      }
			} catch (e) {
				this.$error(e)
			} finally {
				this.spin = false;
			}
    },

	  async sheetChanged(ev){
		  console.log("sheetChanged", ev)
			if (this.initialLoad) return;
		  this.content.sheet_id = ev.id; // can be zero
		  this.content.sheet_name = ev.name;
		  await this.loadSheetFields()
		  this.updated()
	  },
    async loadSheetFields() {
      try {
        this.spin = true;
	      this.selectedFields = {};

	      if (!this.content.spreadsheet_id || !Number.isInteger(this.content.sheet_id)) return;

        let sheetItem = this.sheets.find(item => item.id === this.content.sheet_id);
        let spreadItem = this.spreadSheets.find(item => item.id === this.content.spreadsheet_id);

        if (spreadItem && sheetItem) {
	        let fields = await this.api.integrations.method(this.integration.name, 'get-sheet-fields', {
		        "id": 0,
		        "arg1": this.content.spreadsheet_id,
		        "arg2": sheetItem.name,
	        });
	        this.selectedFields = fields;
        }
      } catch (e) {
				this.$error(e, "Couldn't load sheet columns' data.")
      } finally {
        this.spin = false;
      }
    },
    onMapping(event) {
      let mappings = [];
      event.forEach(item => {
        mappings.push({src: item.src, target: item.target})
      });
			this.$set(this.content, "mappings", mappings);
    }
  },
  async created() {
	  if (this.automation) {
		  if (!this.automation.content)
			  this.$set(this.automation, 'content', {
					mappings:[],
			  })

		  this.initialLoad = true;
		  this.automation.type_id = 1;
		  let spreadsheet_id = this.content.spreadsheet_id;
		  let sheet_id = this.content.sheet_name;

		  console.log("this.content.sheet_name",this.content.sheet_name)
		  await this.loadSpreadsheets();
		  console.log("this.content.sheet_name",this.content.sheet_name)
		  await this.loadSheets();
		  console.log("this.content.sheet_name",this.content.sheet_name)
		  await this.loadSheetFields();
		  console.log("this.content.sheet_name",this.content.sheet_name)

		  this.initialLoad = false;
			this.$emit('valid', this.isValid)
	  }
  }
}
</script>
